<template>
  <div class="info">
    <div class="info_body">
      <div class="info_select">
        <el-select @change="choseTimeRange" v-model="timeSpan">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="info_type">
        <div
          class="info_type_card"
          :key="index"
          v-for="(item, index) in eventLevel"
        >
          <div class="info_type_box">
            <div>{{ item.value }}</div>
            <div>
              <el-badge :type="item.level" is-dot /><span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="info_Form">
        <div class="TitleBar">
          <img
            src="../../../../assets/recycling/temporaryPicture/img_5.png"
            alt=""
          />
          <span>安全事件趋势图</span>
        </div>
        <safe-echarts :chartData="chartData" />
      </div>
      <div class="info_table">
        <div class="TitleBar">
          <img
            src="../../../../assets/recycling/temporaryPicture/img_5.png"
            alt=""
          />
          <span>最新安全处罚事件</span>
        </div>
        <safe-table :timeSpan="timeSpan" />
      </div>
    </div>
  </div>
</template>

<script>
import safeEcharts from '@/views/Regulatory/HOME/PunishmentDetails/component/safeEcharts.vue';
import safeTable from '@/views/Regulatory/HOME/PunishmentDetails/component/safeTable.vue';
import { addPunishment, getPunishmentTrend } from '@/API/Punishment/Punishment';
import { getTimeRange } from '@/util/dateRange';
export default {
  name: 'cardInfomation',
  components: {
    safeEcharts,
    safeTable,
  },
  data() {
    return {
      formData: {},
      dialogTitle: '新增处罚信息',
      options: [
        {
          value: '0',
          label: '近一周',
        },
        {
          value: '1',
          label: '近一个月',
        },
        {
          value: '2',
          label: '近六个月',
        },
        {
          value: '3',
          label: '近一年',
        },
      ],
      timeSpan: '0',
      chartData: [],
      eventLevel: [],
      visible: false,

    };
  },
  mounted() {
    this.getPunishmentTrends();
  },
  methods: {
    choseTimeRange(){
      this.getPunishmentTrends();
    },
    getPunishmentTrends() {
      let parmrs = {
        beginDate: getTimeRange(this.timeSpan).startTime,
        endDate: getTimeRange(this.timeSpan).endTime,
      };
      getPunishmentTrend(parmrs).then((res) => {
        if (res.code === 200) {
          this.chartData = res.data.trends;
          let totalObj =[
            {
              name: '处罚事件',
              levelDesc: '全部',
              value: 0,
              level: 'primary',
            },
            {
              name: '高等级事件',
              levelDesc: '高',
              value: 0,
              level: 'danger',
            },
            {
              name: '中等级事件',
              levelDesc: '中',
              value: 0,
              level: 'warning',
            },
            {
              name: '普通等级事件',
              levelDesc: '低',
              value: 0,
              level: 'info',
            }
          ];
          res.data.classified?.forEach((item) => {
            totalObj[0].value += item.value;
            totalObj.forEach(temp=>{
              if(temp.levelDesc === item.levelDesc){
                temp.value = item.value
              }
            })
          });
          this.eventLevel = Object.assign([], totalObj);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .info{
    padding: unset !important;
    .info_body{
      padding: 0 10px !important;
    }
    .info_type_card{
      height: 40px !important;
      .info_type_box{
        height: 30px !important;
        width: 100% !important;
        div{
          font-size: 12px !important;
        }
        div:last-child {
          line-height: 7px !important;
        }
      }
    }
    .TitleBar{
      padding: 10px !important;
      img{
        height: 16px !important;
        width: 16px !important;
      }
      span{
        font-size: 14px !important;
      }
    }
  }
}
.info {
  width: 100%;
  padding: 0 250px;
  .info_select {
    margin-bottom: 10px;
  }
  .info_type {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .info_type_card {
      width: 24.5%;
      height: 88px;
      border-radius: 8px;
      background: rgb(255, 255, 255);
      display: flex;
      align-items: center;
      justify-content: center;
      .info_type_box {
        height: 58px;
        width: 80%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        div:first-child {
          width: 100%;
          font-size: 24px;
          font-weight: 500;
          line-height: 32px;
          text-align: center;
          color: rgb(34, 34, 34);
        }
        div:last-child {
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          display: flex;
          justify-content: center;
          /deep/.el-badge {
            width: fit-content !important;
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
          span {
            display: inline-block;
            margin-left: 5px;
          }
        }
      }
    }
  }
  .info_Form,
  .info_table {
    width: 100%;
    background-color: #ffffff;
    .TitleBar {
      display: flex;
      align-items: center;
      padding: 16px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: rgb(34, 34, 34);
      }
    }
  }
  .info_Form {
    margin-bottom: 12px;
  }
  .info_table {
    margin-bottom: 12px;
  }
}
</style>
